import React from 'react';
import { motion } from 'framer-motion';

const Login = () => {
  return (
    <div className="page-container">
      <div className="page-header">
        <h1 className="page-title">用戶登入 User Login</h1>
        <p className="page-subtitle">
          登入您的帳戶以參與投票
        </p>
      </div>
      
      <div className="container">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
          className="text-center"
        >
          <div className="card">
            <h2>登入功能開發中</h2>
            <p>用戶登入功能正在開發中，敬請期待！</p>
            <p>Login functionality is under development. Please stay tuned!</p>
          </div>
        </motion.div>
      </div>
    </div>
  );
};

export default Login;
